<template>
  <div class="page">
    <el-form>
      <el-form-item label="型号">
        <el-input></el-input>
      </el-form-item>
      <el-form-item>
        <el-button>搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableList">
      <el-table-column prop="" label="" align="center"></el-table-column>
      <el-table-column prop="" label="商品名称" align="center"></el-table-column>
      <el-table-column prop="" label="商品类型" align="center"></el-table-column>
      <el-table-column prop="" label="商品品牌" align="center"></el-table-column>
      <el-table-column label="操作" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  KSAXApiRequest
} from '../../api/api'
export default {
  data() {
    return {
      tableList: []
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    getTableList() {
      let data = {
        path: 'Product_Spu/CommodityLibrary',
        parmsJson: {
          pageIndex: 1,
          pageSize: 10
        }
      }
      KSAXApiRequest(data).then(res => {

      })
    }
  }
}
</script>

<style>

</style>